// extracted by mini-css-extract-plugin
export default {"scrollBox":"DeviceComponentsHistory_scrollBox__euL9P","noRightPadding":"DeviceComponentsHistory_noRightPadding__2uJ98"};